import { service } from '@maia/cart';
import { queryOptions } from '@tanstack/react-query';

export function getUpsellproductsOptions(guid: string) {
  return queryOptions({
    queryFn: () => service.getUpsellproducts(guid),
    queryKey: ['upsellproducts', guid],
  });
}
